import React from 'react';

/**
 * Generic left panel list item for Pocketbook
 * Displays a primary label and optional subtitle with consistent styling
 */
interface PocketbookListItemProps {
  label: string;
  subtitle?: string | null;
  isSelected: boolean;
}

export const PocketbookListItem: React.FC<PocketbookListItemProps> = ({
  label,
  subtitle,
  isSelected,
}) => {
  return (
    <div
      className={`w-full px-3 py-2 text-left text-sm transition-colors ${
        isSelected ? 'font-medium text-white' : 'text-gray-700'
      }`}
    >
      <div className="truncate">{label}</div>
      {subtitle && (
        <div
          className={`text-xs truncate mt-0.5 ${
            isSelected ? 'text-blue-100' : 'text-gray-500'
          }`}
        >
          {subtitle}
        </div>
      )}
    </div>
  );
};
